import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from 'constants/query-keys';
import { createQueryKey } from 'helpers/ReactQueryHelpers';
import { getRecipesByTag } from 'services/RecipeService/RecipeService';

import type { GetRecipesByTagParams, GetRecipesByTagParams as Params } from 'services/RecipeService/RecipeService';
import type { IRecipesByTagPage, QueryClient, ReactQueryOptions } from 'types';

export function useRecipesByTag(params: Params, queryOptions: ReactQueryOptions<IRecipesByTagPage> = {}) {
  return useQuery({
    queryKey: getKey(params),
    queryFn: () => getRecipesByTag(params),
    ...queryOptions
  });
}

function getKey(params: Params) {
  const {
    identifier, page, itemsPerPage, preview
  } = params;

  return createQueryKey([
    QUERY_KEYS.RECIPES_BY_TAG,
    identifier,
    page,
    itemsPerPage,
    preview
  ]);
}

export async function prefetchRecipesByTag(
  params: GetRecipesByTagParams,
  queryClient: QueryClient,
): Promise<boolean> {
  try {
    const data = await queryClient.fetchQuery({
      queryKey: getKey(params),
      queryFn: () => getRecipesByTag(params)
    });
    return !!data;
  } catch (err) {
    return false;
  }
}
